import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/_modules/_app/customers/stores')({
  staticData: {
    title: 'route.stores',
    crumb: 'route.stores',
    permissions: ['customers_stores_view'],
  },
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
